import { useEffect, useRef, useState } from 'react';

export function useScrollReveal<T extends HTMLElement = HTMLDivElement>(threshold = 0.2) {
  const ref = useRef<T>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          obs.disconnect();
        }
      },
      { threshold }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [threshold]);

  return [ref, visible] as const;
}

export const DEMO_BRAND = {
  blue: '#004790',
  blueDark: '#003366',
  blueLight: '#e8f1fa',
  cream: '#faf7f2',
  ink: '#0a1024',
  midnight: '#0d1b3e',
  dark: '#0f172a',
  mid: '#475569',
  muted: '#94a3b8',
  hairline: '#e2e8f0',
  amber: '#c08838',
  amberSoft: '#f3e4c4',
  green: '#16a34a',
  greenBg: '#dcfce7',
  indigo: '#6366f1',
};
